// extracted by mini-css-extract-plugin
export default {"carousel-dot-list":"List_carousel-dot-list__I9OtZ","button":"List_button__uzp1a"};